import { useCallback } from "react";
import api from "../../../services/api";

interface ColumnReorderHandlerProps {
  apiRef: any;
  viewId: any;
  subViewId: any;
  schema: any;
  visibleColumns: Record<string, any>;
  setVisibleColumns: (columns: Record<string, any>) => void;
}

const ColumnReorderHandler = ({
                                apiRef,
                                viewId,
                                subViewId,
                                schema,
                                visibleColumns,
                                setVisibleColumns,
                              }: ColumnReorderHandlerProps) => {

  const reorderColumns = useCallback(
    (oldIndex: number, targetIndex: number) => {
      const id = viewId || subViewId;

      const cols = [...apiRef.current.getVisibleColumns()]
        .slice(1)
        .map((item: any) => {
          return {
            name: item?.field,
          };
        });

      api.patch(`/views/${id}`, {
        columns: cols,
      });

      const columnsArray = Object.entries(visibleColumns);

      const addOne = schema?.treeData ? -1 : schema?.hasCheckField ? 0 : 0;

      const [movedColumn] = columnsArray.splice(oldIndex + addOne, 1);

      columnsArray.splice(targetIndex + addOne, 0, movedColumn);
      const updatedColumns = Object.fromEntries(columnsArray);

      setVisibleColumns(updatedColumns);
    },
    [apiRef, viewId, subViewId, schema, visibleColumns, setVisibleColumns]
  );

  return reorderColumns;
};

export default ColumnReorderHandler;